import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

// Content
import Contact from "../components/Contact";

function Contacts() {
    return (
        <>
        <Navigation />
        <Contact />
        <Footer />

    </>
    )
}

export default Contacts;